import { BriefType } from "../../../constants/types";
import { IPermissions } from "../../../types/user/permissions/ipermissions/ipermissions.interface";

import { OtisForm } from "../../forms/forms.hook";

export const pageType = BriefType.WORK_ORDER;

export interface IWorkOrderTemplate {
  form: OtisForm<any>;
  pageTitle?: string;
  resourceId: number;
  resourceType: string;
  userPermissions: IPermissions;
}

export { WorkOrderSimpleTemplate } from "./simple";
export { WorkOrderWebTemplate } from "./web";
export { WorkOrderDealerAdvertisingTemplate } from "./dealerAdvertising";
export { WorkOrderInStorePrintTemplate } from "./inStorePrint";
export { WorkOrderInStoreDigitalTemplate } from "./inStoreDigital";
export { WorkOrderPaidMediaTemplate } from "./paidMedia";
